import { INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130 } from "@faire/web-api--source/indigofair/settings/INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingInsiderThresholdForNonInsidersEnabled = (): boolean =>
  getSettingValueAndAssign(
    INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130,
    false
  );
